<template>
  <DpplHeaderFooterContent :class="{ 'is-loading': props.isLoading }">
    <template #header>
      <SearchBar
        class="px-4 pb-4"
        :jobs="props.jobs"
        :is-loading="props.isLoading"
        @search="emit('search', $event)"
        @locality-change="emit('locality-change', $event)"
        @scope-change="emit('scope-change', $event)"
        @search-upgrade="emit('search-upgrade', $event)"
      />
    </template>

    <div class="d-flex flex-column ga-4 w-100">
      <List
        :jobs="props.jobs"
        @card-click="emit('card-click', $event)"
      />
      <v-btn
        v-if="props.showSeeMore"
        class="mx-4 more-jobs-button"
        rounded="lg"
        height="32"
        color="primary"
        variant="outlined"
        size="small"
        @click="emit('load-more')"
      >
        See more
      </v-btn>
    </div>
  </DpplHeaderFooterContent>
</template>

<script setup>
import DpplHeaderFooterContent from '@ui/components/general/DpplHeaderFooterContent/DpplHeaderFooterContent.vue';
import SearchBar from './SearchBar.vue';
import List from './List.vue';

const emit = defineEmits(['search', 'locality-change', 'scope-change', 'card-click', 'load-more', 'search-upgrade']);

const props = defineProps({
  jobs: {
    type: Array,
    required: true,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    required: true,
    default: false,
  },
  showSeeMore: {
    type: Boolean,
    required: true,
    default: true,
  },
});
</script>

<style scoped lang="less">
.more-jobs-button {
  border-color: @stroke-default;
}

.is-loading {
  pointer-events: none;
  opacity: 0.5;
  user-select: none;
}
</style>
